<script>
import Layout from '@src/router/layouts/main'
import loteService from '@/src/services/api-receituario/lote'
import produtoService from '@/src/services/produto_estoque'
import produtorService from '@/src/services/produtor-rural'
import moment from 'moment'
moment.locale('pt-br')

const emptyForm = () => ({
  id: null,
  idProduto: null,
  product: '',
  lotNumber: '',
  idFornecedor: null,
  supplier: '',
  invoice: '',
  fabricationDate: '',
  expirationDate: '',
  entryDate: '',
  initialQuantity: 0,
  currentQuantity: 0,
  status: 'Ativo',
  notes: '',
})

export default {
  components: {
    Layout,
  },
  data() {
    return {
      showForm: false,
      isLoading: false,
      isLoadingProdutos: false,
      isLoadingFornecedores: false,
      fornecedorSearchTerm: '',
      fornecedorSearchDebounce: null,
      showFornecedorAutocomplete: false,
      showFilterSidebar: false,
      categoria: 'Todas as Categorias',
      status: 'Todos os Status',
      periodo: 'Qualquer Período',
      form: emptyForm(),
      productOptions: [],
      supplierOptions: [],
      categorias: [
        'Todas as Categorias',
        'Polímeros',
        'Pigmentos',
        'Resinas',
        'Solventes',
      ],
      statusOptions: ['Todos os Status', 'Ativo', 'Inativo', 'Atenção', 'Vencido', 'Quarentena'],
      periodoOptions: [
        'Qualquer Período',
        'Próximos 30 dias',
        'Próximos 90 dias',
        'Vencidos',
      ],
      lots: [],
      rows: 0,
      currentPage: 1,
      perPage: 20,
    }
  },
  computed: {
    totalLotes() {
      return this.rows || this.lots.length
    },
    lotesAtencao() {
      return this.lots.filter((lot) => lot.status === 'Atenção').length
    },
    lotesVencidos() {
      return this.lots.filter((lot) => lot.status === 'Vencido').length
    },
    estoqueAtivo() {
      return this.lots.reduce((total, lot) => total + Number(lot.currentQuantity || 0), 0)
    },
    filteredLots() {
      return this.lots
    },
    totalFiltrosAplicados() {
      return [
        this.categoria !== 'Todas as Categorias' ? this.categoria : '',
        this.status !== 'Todos os Status' ? this.status : '',
        this.periodo !== 'Qualquer Período' ? this.periodo : '',
      ].filter(Boolean).length
    },
  },
  watch: {
    currentPage() {
      this.listLots()
    },
  },
  mounted() {
    this.listLots()
    this.handleGetProduto()
    this.handleGetFornecedor()
  },
  methods: {
    token() {
      return this.$store.state.auth.currentUser.token
    },
    formatDate(date) {
      if (!date) return '--/--/----'
      const formatted = moment.utc(date).format('DD/MM/YYYY')
      return formatted !== 'Invalid date' ? formatted : date
    },
    formatDateInput(date) {
      if (!date) return ''
      const formatted = moment.utc(date).format('YYYY-MM-DD')
      return formatted !== 'Invalid date' ? formatted : ''
    },
    normalizeStatus(lot) {
      const status = lot.status || lot.situacao || lot.ativo
      if (typeof status === 'boolean') return status ? 'Ativo' : 'Inativo'
      if (!status) {
        const expiration = lot.data_validade || lot.validade || lot.expirationDate
        if (expiration && moment.utc(expiration).isBefore(moment(), 'day')) return 'Vencido'
        if (expiration && moment.utc(expiration).diff(moment(), 'days') <= 30) return 'Atenção'
        return 'Ativo'
      }
      const normalized = String(status).toUpperCase()
      if (normalized === 'ATIVO') return 'Ativo'
      if (normalized === 'ATENCAO' || normalized === 'ATENÇÃO') return 'Atenção'
      if (normalized === 'VENCIDO') return 'Vencido'
      if (normalized === 'QUARENTENA' || normalized === 'EM QUARENTENA') return 'Quarentena'
      if (normalized === 'INATIVO') return 'Inativo'
      return status
    },
    normalizeLot(lot) {
      const productId = lot.id_produto || lot.produto_id || lot.idProduto
      const fornecedorId = lot.id_fornecedor || lot.fornecedor_id || lot.idFornecedor
      const currentQuantity = this.firstDefined([
        lot.quantidade_atual,
        lot.quantidade_disponivel,
        lot.quantidade,
        lot.currentQuantity,
        0,
      ])
      const initialQuantity = this.firstDefined([
        lot.quantidade_inicial,
        lot.initialQuantity,
        currentQuantity,
      ])
      return {
        ...lot,
        id: lot.id_lote || lot.id || lot.idLote,
        idProduto: productId,
        idFornecedor: fornecedorId,
        code: lot.numero_lote || lot.lote || lot.codigo || lot.code || '',
        product: lot.nome_produto || lot.produto || lot.product || lot.nome || '',
        productId: productId ? `ID: ${productId}` : '--',
        supplier: lot.nome_fornecedor || lot.fornecedor || lot.supplier || '',
        invoice: lot.n_nf || lot.nota_fiscal || lot.invoice || '',
        fabricationDate: this.formatDateInput(lot.data_fabricacao || lot.fabricacao || lot.fabricationDate),
        expirationDate: this.formatDateInput(lot.data_validade || lot.validade || lot.expirationDate),
        entryDate: this.formatDateInput(lot.data_entrada || lot.data_cadastro || lot.entryDate),
        fabrication: this.formatDate(lot.data_fabricacao || lot.fabricacao || lot.fabricationDate),
        expiration: this.formatDate(lot.data_validade || lot.validade || lot.expirationDate),
        initialQuantity,
        currentQuantity,
        quantity: this.formatQuantity(currentQuantity, lot.unidade || lot.unidade_medida),
        status: this.normalizeStatus(lot),
        notes: lot.observacoes || lot.notes || '',
      }
    },
    formatQuantity(quantity, unit = 'unid.') {
      const value = Number(quantity || 0)
      return `${value.toLocaleString('pt-BR')} ${unit || 'unid.'}`
    },
    firstDefined(values) {
      return values.find((value) => value !== undefined && value !== null)
    },
    getListParams() {
      return {
        take: this.perPage,
        page: this.currentPage,
        categoria: this.categoria !== 'Todas as Categorias' ? this.categoria : undefined,
        status: this.status !== 'Todos os Status' ? this.status : undefined,
        periodo: this.periodo !== 'Qualquer Período' ? this.periodo : undefined,
      }
    },
    listLots() {
      this.isLoading = true
      loteService
        .listar(this.token(), this.getListParams())
        .then((response) => {
          const data = response.data || {}
          const rows = Array.isArray(data) ? data : data.lotes || data.lots || data.dados || data.data || []
          this.lots = Array.isArray(rows) ? rows.map(this.normalizeLot) : []
          this.rows = data.count || data.total || this.lots.length
        })
        .catch(() => {
          this.lots = []
          this.rows = 0
          this.$bvToast.toast('Não foi possível listar os lotes.', {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    openNewLot() {
      this.form = emptyForm()
      this.fornecedorSearchTerm = ''
      this.showFornecedorAutocomplete = false
      this.showForm = true
    },
    cancelNewLot() {
      this.showForm = false
      this.form = emptyForm()
      this.fornecedorSearchTerm = ''
      this.showFornecedorAutocomplete = false
    },
    clearFilters() {
      this.categoria = 'Todas as Categorias'
      this.status = 'Todos os Status'
      this.periodo = 'Qualquer Período'
      this.showFilterSidebar = false
      this.applyFilters()
    },
    applyFilters() {
      this.showFilterSidebar = false
      if (this.currentPage === 1) {
        this.listLots()
        return
      }
      this.currentPage = 1
    },
    statusClass(status) {
      return `is-${status.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')}`
    },
    isExpired(lot) {
      return lot.status === 'Vencido' || lot.status === 'Atenção'
    },
    getPayload() {
      return {
        id: this.form.id,
        id_lote: this.form.id,
        id_produto: this.form.idProduto,
        produto: this.form.product,
        numero_lote: this.form.lotNumber,
        id_fornecedor: this.form.idFornecedor,
        fornecedor: this.form.supplier,
        n_nf: this.form.invoice,
        data_fabricacao: this.form.fabricationDate || null,
        data_validade: this.form.expirationDate || null,
        data_entrada: this.form.entryDate || null,
        quantidade_inicial: Number(this.form.initialQuantity || 0),
        quantidade_atual: Number(this.form.currentQuantity || this.form.initialQuantity || 0),
        status: this.form.status,
        observacoes: this.form.notes,
      }
    },
    saveLot(createNew = false) {
      const payload = this.getPayload()
      if (!payload.id_produto || !payload.numero_lote || !payload.data_validade) {
        this.$bvToast.toast('Informe produto, número do lote e validade.', {
          variant: 'warning',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
        return
      }
      this.isLoading = true
      const request = payload.id
        ? loteService.update(this.token(), payload)
        : loteService.salvar(this.token(), payload)
      request
        .then(() => {
          this.$bvToast.toast(payload.id ? 'Lote atualizado com sucesso!' : 'Lote cadastrado com sucesso!', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
      this.form = emptyForm()
      this.fornecedorSearchTerm = ''
      this.showForm = createNew
      this.listLots()
        })
        .catch((error) => {
          const message = error.response
            ? error.response.data.data || error.response.data.message || 'Erro ao salvar lote.'
            : 'Erro ao salvar lote.'
          this.$bvToast.toast(Array.isArray(message) ? message.join(', ') : message, {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    editLot(lot) {
      this.isLoading = true
      loteService
        .consultar(this.token(), lot.id)
        .then((response) => {
          const data = response.data || {}
          this.fillFormFromLot(this.normalizeLot(data.lote || data.lot || data.dado || data))
        })
        .catch(() => {
          this.fillFormFromLot(lot)
        })
        .finally(() => {
          this.isLoading = false
          this.showForm = true
        })
    },
    fillFormFromLot(lot) {
      this.ensureSelectedProduct(lot)
      this.ensureSelectedFornecedor(lot)
      this.form = {
        id: lot.id,
        idProduto: lot.idProduto,
        product: lot.product,
        lotNumber: lot.code,
        idFornecedor: lot.idFornecedor,
        supplier: lot.supplier,
        invoice: lot.invoice,
        fabricationDate: lot.fabricationDate,
        expirationDate: lot.expirationDate,
        entryDate: lot.entryDate,
        initialQuantity: lot.initialQuantity,
        currentQuantity: lot.currentQuantity,
        status: lot.status,
        notes: lot.notes,
      }
      this.fornecedorSearchTerm = lot.supplier || ''
    },
    deleteLot(lot) {
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja excluir este lote?', {
          title: 'Aviso',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          okVariant: 'danger',
          cancelVariant: 'light',
          centered: true,
        })
        .then((confirmed) => {
          if (!confirmed) return
          this.isLoading = true
          loteService
            .deletar(this.token(), lot.id)
            .then(() => {
              this.$bvToast.toast('Lote excluído com sucesso!', {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
              this.listLots()
            })
            .catch((error) => {
              const message = error.response
                ? error.response.data.data || error.response.data.message || 'Erro ao excluir lote.'
                : 'Erro ao excluir lote.'
              this.$bvToast.toast(Array.isArray(message) ? message.join(', ') : message, {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            })
            .finally(() => {
              this.isLoading = false
            })
        })
    },
    handleGetProduto(search = '') {
      this.isLoadingProdutos = true
      return produtoService
        .listarNotFilter(this.token(), 20, 1, search ? { nome: search } : {})
        .then((response) => {
          this.productOptions = this.extractRows(response.data, ['produtos', 'dados'])
        })
        .finally(() => {
          this.isLoadingProdutos = false
        })
    },
    handleProdutoSearch(search, loading) {
      if (loading) loading(true)
      this.handleGetProduto(search).finally(() => {
        if (loading) loading(false)
      })
    },
    onProductSelected(productId) {
      const product = this.productOptions.find((item) => item.id_produto === productId)
      this.form.product = product ? product.nome : this.form.product
    },
    ensureSelectedProduct(lot) {
      if (!lot.idProduto || !lot.product) return
      const exists = this.productOptions.some((item) => item.id_produto === lot.idProduto)
      if (!exists) {
        this.productOptions.push({
          id_produto: lot.idProduto,
          nome: lot.product,
        })
      }
    },
    handleGetFornecedor(search = '') {
      this.isLoadingFornecedores = true
      const request = search
        ? produtorService.listarByFilter(this.token(), search, 1, 20)
        : produtorService.listar(this.token(), 1, 20)
      return request
        .then((response) => {
          this.supplierOptions = this.extractRows(response.data, ['produtores', 'dados'])
        })
        .catch(() => {
          this.supplierOptions = []
          this.$bvToast.toast('Não foi possível carregar os fornecedores.', {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        })
        .finally(() => {
          this.isLoadingFornecedores = false
        })
    },
    handleFornecedorSearch(search, loading) {
      if (loading) loading(true)
      this.handleGetFornecedor(search).finally(() => {
        if (loading) loading(false)
      })
    },
    handleFornecedorInput() {
      this.showFornecedorAutocomplete = true
      this.form.idFornecedor = null
      this.form.supplier = ''
      if (this.fornecedorSearchDebounce) {
        clearTimeout(this.fornecedorSearchDebounce)
      }
      this.fornecedorSearchDebounce = setTimeout(() => {
        this.handleGetFornecedor(this.fornecedorSearchTerm)
      }, 350)
    },
    handleFornecedorFocus() {
      this.showFornecedorAutocomplete = true
      if (!this.supplierOptions.length) {
        this.handleGetFornecedor(this.fornecedorSearchTerm)
      }
    },
    handleFornecedorBlur() {
      setTimeout(() => {
        this.showFornecedorAutocomplete = false
        if (!this.fornecedorSearchTerm) {
          this.form.idFornecedor = null
          this.form.supplier = ''
        }
      }, 150)
    },
    extractRows(data, keys) {
      if (Array.isArray(data)) return data
      if (!data) return []
      for (const key of keys) {
        const value = data[key]
        if (Array.isArray(value)) return value
        if (value && Array.isArray(value.dados)) return value.dados
        if (value && Array.isArray(value.data)) return value.data
        if (value && Array.isArray(value.rows)) return value.rows
      }
      if (Array.isArray(data.data)) return data.data
      if (Array.isArray(data.rows)) return data.rows
      return []
    },
    fornecedorLabel(item) {
      if (!item) return 'Fornecedor'
      return item.nome || item.nome_produtor || item.razao_social || item.cpf_cnpj || 'Fornecedor'
    },
    fornecedorId(item) {
      return item.id_produtor_rural || item.id || item.id_produtor
    },
    fornecedorMeta(item) {
      return item.cpf_cnpj || item.cpfcnpj || item.documento || item.endereco || ''
    },
    selectFornecedor(fornecedor) {
      this.form.idFornecedor = this.fornecedorId(fornecedor)
      this.form.supplier = this.fornecedorLabel(fornecedor)
      this.fornecedorSearchTerm = this.form.supplier
      this.showFornecedorAutocomplete = false
    },
    ensureSelectedFornecedor(lot) {
      if (!lot.idFornecedor || !lot.supplier) return
      const exists = this.supplierOptions.some((item) => {
        return this.fornecedorId(item) === lot.idFornecedor
      })
      if (!exists) {
        this.supplierOptions.push({
          id_produtor_rural: lot.idFornecedor,
          nome: lot.supplier,
        })
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco lot-page">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-7 mb-2">
            <div class="titulo">
              <i class="uil uil-box"></i>
              {{ showForm ? 'Novo Cadastro de Lote' : 'Lotes' }}
            </div>
            <div class="subTitulo">
              {{ showForm ? 'Cadastre as informações, validade e quantidade inicial do lote.' : 'Acompanhe validade, status e volume dos lotes em estoque.' }}
            </div>
          </div>
          <div class="col-md-5">
            <div class="lot-page-actions">
              <button
                v-if="!showForm"
                class="btn btn-light"
                type="button"
                @click="showFilterSidebar = true"
              >
                <i class="uil uil-filter"></i>
                Filtros
                <b-badge v-if="totalFiltrosAplicados" variant="primary">{{ totalFiltrosAplicados }}</b-badge>
              </button>
              <button
                v-if="showForm"
                class="btn btn-light"
                type="button"
                @click="cancelNewLot()"
              >
                <i class="uil uil-arrow-left"></i>
                Voltar
              </button>
              <button class="btn btn-webreceita" type="button" @click="showForm ? saveLot() : openNewLot()">
                <i :class="showForm ? 'uil uil-save' : 'uil uil-plus-circle'"></i>
                {{ showForm ? 'Salvar' : 'Novo' }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="borda"></div>
        </div>
      </div>

      <div v-if="!showForm" class="lot-dashboard">
        <section class="lot-kpi-grid">
          <article class="lot-kpi-card">
            <div>
              <span>Total de Lotes</span>
              <strong>{{ totalLotes }}</strong>
              <small class="is-positive"><i class="uil uil-chart-growth"></i> Registros cadastrados</small>
            </div>
            <i class="lot-kpi-icon is-positive uil uil-clipboard-notes"></i>
          </article>
          <article class="lot-kpi-card">
            <div>
              <span>Próximos ao Vencimento</span>
              <strong>{{ lotesAtencao }}</strong>
              <small class="is-warning"><i class="uil uil-exclamation-triangle"></i> Próximos 30 dias</small>
            </div>
            <i class="lot-kpi-icon is-warning uil uil-stopwatch"></i>
          </article>
          <article class="lot-kpi-card">
            <div>
              <span>Lotes Vencidos</span>
              <strong class="is-danger">{{ lotesVencidos }}</strong>
              <small class="is-danger"><i class="uil uil-exclamation-circle"></i> Ação imediata necessária</small>
            </div>
            <i class="lot-kpi-icon is-danger uil uil-calendar-slash"></i>
          </article>
          <article class="lot-kpi-card">
            <div>
              <span>Estoque Ativo</span>
              <strong>{{ estoqueAtivo.toLocaleString('pt-BR') }}</strong>
              <small>Volume total em unidades</small>
            </div>
            <i class="lot-kpi-icon is-neutral uil uil-cube"></i>
          </article>
        </section>

        <section class="lot-table-card">
          <div class="lot-table-wrap">
            <table class="lot-table">
              <thead>
                <tr>
                  <th>Lote</th>
                  <th>Produto</th>
                  <th>Fabr.</th>
                  <th>Validade</th>
                  <th>Qtd</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="lot in filteredLots" :key="lot.id || lot.code">
                  <td>
                    <strong class="lot-code">{{ lot.code }}</strong>
                  </td>
                  <td>
                    <strong>{{ lot.product }}</strong>
                    <small>{{ lot.productId }}</small>
                  </td>
                  <td>{{ lot.fabrication }}</td>
                  <td>
                    <strong :class="{ 'is-expired': isExpired(lot) }">
                      {{ lot.expiration }}
                    </strong>
                  </td>
                  <td>{{ lot.quantity }}</td>
                  <td>
                    <span :class="['lot-status', statusClass(lot.status)]">
                      {{ lot.status }}
                    </span>
                  </td>
                  <td>
                    <b-dropdown
                      class="lot-actions-menu"
                      toggle-class="lot-actions-toggle"
                      variant="link"
                      no-caret
                      dropleft
                    >
                      <template v-slot:button-content>
                        <i class="uil uil-ellipsis-v"></i>
                      </template>
                      <b-dropdown-item @click="editLot(lot)">
                        <i class="uil uil-edit"></i>
                        Editar
                      </b-dropdown-item>
                      <b-dropdown-item @click="deleteLot(lot)">
                        <i class="uil uil-trash-alt"></i>
                        Excluir
                      </b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
                <tr v-if="!filteredLots.length">
                  <td colspan="7" class="lot-empty">
                    Nenhum lote encontrado para os filtros selecionados.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <footer class="lot-table-footer">
            <span>Exibindo {{ filteredLots.length }} de {{ totalLotes }} lotes</span>
            <b-pagination
              v-model="currentPage"
              size="md"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </footer>
        </section>
      </div>

      <div v-else class="lot-dashboard">
        <div class="lot-form-grid">
          <main class="lot-form-main">
            <section class="lot-form-card">
              <h2><i class="uil uil-info-circle"></i> Informações do Lote</h2>
              <div class="lot-form-fields two-columns">
                <b-form-group label="Produto">
                  <v-select
                    v-model="form.idProduto"
                    class="style-select"
                    :options="productOptions"
                    :reduce="(item) => item.id_produto"
                    label="nome"
                    placeholder="Buscar produto"
                    :loading="isLoadingProdutos"
                    @input="onProductSelected"
                    @search="handleProdutoSearch"
                  />
                </b-form-group>
                <b-form-group label="Número do Lote">
                  <b-form-input v-model="form.lotNumber" placeholder="Ex: LOT-2024-001" />
                </b-form-group>
                <b-form-group label="Fornecedor">
                  <div class="lot-autocomplete">
                    <b-form-input
                      v-model="fornecedorSearchTerm"
                      autocomplete="off"
                      placeholder="Buscar fornecedor"
                      @focus="handleFornecedorFocus"
                      @blur="handleFornecedorBlur"
                      @input="handleFornecedorInput"
                    />
                    <button
                      v-if="fornecedorSearchTerm"
                      class="lot-autocomplete-clear"
                      type="button"
                      @mousedown.prevent
                      @click="fornecedorSearchTerm = ''; form.idFornecedor = null; form.supplier = ''"
                    >
                      <i class="uil uil-times"></i>
                    </button>
                    <div v-if="showFornecedorAutocomplete" class="lot-autocomplete-menu">
                      <div v-if="isLoadingFornecedores" class="lot-autocomplete-state">
                        Buscando fornecedores...
                      </div>
                      <button
                        v-for="item in supplierOptions"
                        :key="fornecedorId(item)"
                        class="lot-autocomplete-item"
                        type="button"
                        @mousedown.prevent="selectFornecedor(item)"
                      >
                        <span>{{ fornecedorLabel(item) }}</span>
                        <small v-if="fornecedorMeta(item)">{{ fornecedorMeta(item) }}</small>
                      </button>
                      <div
                        v-if="!isLoadingFornecedores && !supplierOptions.length"
                        class="lot-autocomplete-state"
                      >
                        Nenhum fornecedor encontrado.
                      </div>
                    </div>
                  </div>
                </b-form-group>
                <b-form-group label="Nota Fiscal de Entrada">
                  <b-form-input v-model="form.invoice" placeholder="000.000.000" />
                </b-form-group>
              </div>
            </section>

            <section class="lot-form-card">
              <h2><i class="uil uil-calendar-alt"></i> Datas e Quantidades</h2>
              <div class="lot-form-fields three-columns">
                <b-form-group label="Data de Fabricação">
                  <b-form-datepicker
                    v-model="form.fabricationDate"
                    class="lot-date-field"
                    locale="pt-br"
                    placeholder="Selecione a data"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    reset-button
                    label-reset-button="Limpar"
                  >
                    <template v-slot:button-content>
                      <b-icon icon="calendar" variant="primary"></b-icon>
                    </template>
                  </b-form-datepicker>
                </b-form-group>
                <b-form-group label="Data de Validade">
                  <b-form-datepicker
                    v-model="form.expirationDate"
                    class="lot-date-field"
                    locale="pt-br"
                    placeholder="Selecione a data"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    reset-button
                    label-reset-button="Limpar"
                  >
                    <template v-slot:button-content>
                      <b-icon icon="calendar" variant="primary"></b-icon>
                    </template>
                  </b-form-datepicker>
                </b-form-group>
                <b-form-group label="Data de Entrada">
                  <b-form-datepicker
                    v-model="form.entryDate"
                    class="lot-date-field"
                    locale="pt-br"
                    placeholder="Selecione a data"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    reset-button
                    label-reset-button="Limpar"
                  >
                    <template v-slot:button-content>
                      <b-icon icon="calendar" variant="primary"></b-icon>
                    </template>
                  </b-form-datepicker>
                </b-form-group>
              </div>
              <div class="lot-form-fields two-columns has-separator">
                <b-form-group label="Quantidade Inicial">
                  <b-input-group append="unid.">
                    <b-form-input v-model="form.initialQuantity" type="number" />
                  </b-input-group>
                </b-form-group>
                <b-form-group label="Quantidade Atual">
                  <b-input-group append="unid.">
                    <b-form-input v-model="form.currentQuantity" type="number" />
                  </b-input-group>
                  <small>Calculado automaticamente</small>
                </b-form-group>
              </div>
            </section>

            <section class="lot-form-card">
              <h2><i class="uil uil-clipboard-notes"></i> Status e Observações</h2>
              <b-form-group label="Situação do Lote" class="lot-radio-group">
                <b-form-radio-group v-model="form.status">
                  <b-form-radio value="Ativo">Ativo</b-form-radio>
                  <b-form-radio value="Inativo">Inativo</b-form-radio>
                  <b-form-radio value="Quarentena">Em Quarentena</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-group label="Observações">
                <b-form-textarea
                  v-model="form.notes"
                  rows="5"
                  placeholder="Insira detalhes adicionais sobre o lote, condições de armazenamento ou restrições..."
                />
              </b-form-group>
            </section>
          </main>
        </div>
      </div>
      <b-sidebar
        id="lot-filter-sidebar"
        v-model="showFilterSidebar"
        title="Filtros"
        right
        shadow
        backdrop
        width="380px"
        body-class="lot-filter-sidebar-body"
      >
        <b-form class="lot-filter-form" @submit.prevent="applyFilters">
          <b-form-group label="Categoria do Produto">
            <b-form-select v-model="categoria" :options="categorias" />
          </b-form-group>

          <b-form-group label="Status">
            <b-form-select v-model="status" :options="statusOptions" />
          </b-form-group>

          <b-form-group label="Período de Vencimento">
            <b-form-select v-model="periodo" :options="periodoOptions" />
          </b-form-group>

          <div class="lot-filter-sidebar-actions">
            <button class="btn btn-light" type="button" @click="clearFilters">
              Limpar filtros
            </button>
            <button class="btn btn-webreceita" type="submit">
              <i class="uil uil-search"></i>
              Aplicar filtros
            </button>
          </div>
        </b-form>
      </b-sidebar>
      <b-overlay :show="isLoading" no-wrap />
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
.bloco.lot-page {
  background: #fff;
  border: 1px solid #e3e8ef;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.05);
  margin-top: 24px;
  padding: 32px;
  position: relative;
}

.lot-page .titulo {
  align-items: center;
  color: #008e75;
  display: flex;
  font-size: 25px;
  font-weight: 800;
  gap: 8px;
  line-height: 1.2;
  margin-bottom: 8px;
}

.lot-page .subTitulo {
  color: #536074;
  font-size: 14px;
}

.lot-page .borda {
  border-bottom: 1px solid #edeff4;
  margin: 15px 0 18px;
}

.lot-page-actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
}

.lot-page-actions .btn {
  align-items: center;
  border-radius: 5px;
  display: inline-flex;
  font-weight: 700;
  gap: 7px;
  height: 42px;
  justify-content: center;
  margin: 0;
  min-width: 130px;
  padding: 0 18px;
}

.btn-light {
  background: #fff;
  border: 1px solid #d8dee8;
  color: #172033;
}

.btn-webreceita {
  background: #008e75;
  border-color: #008e75;
  color: #fff;
}

.lot-dashboard {
  background: #f5f7fb;
  display: grid;
  gap: 18px;
  margin: 0 -32px -32px;
  padding: 18px 32px 32px;
}

.lot-kpi-grid {
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.lot-kpi-card,
.lot-table-card {
  background: #fff;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
}

.lot-kpi-card {
  align-items: center;
  display: flex;
  justify-content: space-between;
  min-height: 118px;
  padding: 18px 20px;
}

.lot-kpi-card span {
  color: #536074;
  display: block;
  font-size: 12px;
  font-weight: 800;
  margin-bottom: 8px;
}

.lot-kpi-card strong {
  color: #172033;
  display: block;
  font-size: 28px;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 10px;
}

.lot-kpi-card strong.is-danger {
  color: #dc3545;
}

.lot-kpi-card small {
  color: #536074;
  display: block;
  font-size: 11px;
  font-weight: 800;
}

.lot-kpi-card small.is-positive { color: #008e75; }
.lot-kpi-card small.is-warning { color: #b86e12; }
.lot-kpi-card small.is-danger { color: #dc3545; }

.lot-kpi-icon {
  align-items: center;
  border-radius: 8px;
  display: inline-flex;
  flex: 0 0 46px;
  font-size: 22px;
  height: 46px;
  justify-content: center;
  width: 46px;
}

.lot-kpi-icon.is-positive { background: #e3f7f1; color: #008e75; }
.lot-kpi-icon.is-warning { background: #fff0f1; color: #b45d59; }
.lot-kpi-icon.is-danger { background: #ffe9ed; color: #dc3545; }
.lot-kpi-icon.is-neutral { background: #eef1f2; color: #536074; }

.lot-page ::v-deep .lot-filter-sidebar-body {
  padding: 18px 20px 84px;
}

.lot-filter-form ::v-deep .form-group {
  margin-bottom: 16px;
}

.lot-filter-form ::v-deep label {
  color: #172033;
  font-size: 13px;
  font-weight: 800;
}

.lot-filter-form ::v-deep .custom-select {
  border: 1px solid #d8dee8;
  border-radius: 5px;
  color: #536074;
  font-weight: 700;
  height: 42px;
  min-height: 42px;
}

.lot-filter-form ::v-deep .custom-select:focus {
  border-color: #008e75;
  box-shadow: 0 0 0 3px rgba(0, 142, 117, 0.12);
}

.lot-filter-sidebar-actions {
  align-items: center;
  background: #fff;
  border-top: 1px solid #e7edf4;
  bottom: 0;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  left: 0;
  padding: 14px 20px;
  position: absolute;
  right: 0;
  width: 100%;
}

.lot-filter-sidebar-actions .btn {
  align-items: center;
  border-radius: 5px;
  border-width: 1px;
  display: inline-flex;
  font-weight: 800;
  gap: 7px;
  height: 42px;
  justify-content: center;
  margin: 0;
  min-width: 138px;
  padding: 0 18px;
  white-space: nowrap;
}

.lot-filter-sidebar-actions .btn-light {
  background: #fff;
  border-color: #d8dee8;
  color: #172033;
}

.lot-filter-sidebar-actions .btn-webreceita {
  min-width: 178px;
}

.lot-table-card {
  overflow: hidden;
}

.lot-table-wrap {
  overflow-x: auto;
}

.lot-table {
  border-collapse: collapse;
  min-width: 900px;
  width: 100%;
}

.lot-table th {
  background: #eef3fb;
  color: #536074;
  font-size: 12px;
  font-weight: 800;
  padding: 16px 20px;
  text-align: left;
  text-transform: uppercase;
}

.lot-table td {
  border-top: 1px solid #e7edf4;
  color: #536074;
  font-size: 14px;
  font-weight: 700;
  padding: 18px 20px;
  vertical-align: middle;
}

.lot-table td > strong {
  color: #172033;
  display: block;
  font-size: 14px;
  font-weight: 800;
}

.lot-table td small {
  color: #7b8796;
  display: block;
  font-size: 11px;
  font-weight: 700;
  margin-top: 3px;
}

.lot-code {
  color: #008e75 !important;
}

.is-expired {
  color: #dc3545 !important;
}

.lot-status {
  border-radius: 999px;
  display: inline-flex;
  font-size: 11px;
  font-weight: 800;
  padding: 5px 12px;
  text-transform: uppercase;
}

.lot-status.is-ativo {
  background: #e4f6f0;
  color: #008e75;
}

.lot-status.is-atencao {
  background: #fff0f2;
  color: #b45d59;
}

.lot-status.is-vencido {
  background: #ffe9ed;
  color: #dc3545;
}

.lot-status.is-quarentena {
  background: #e6f0ef;
  color: #536074;
}

.lot-actions-menu {
  display: inline-flex;
}

.lot-actions-menu ::v-deep .lot-actions-toggle {
  align-items: center;
  border: 1px solid #d8dee8;
  border-radius: 5px;
  color: #536074;
  display: inline-flex;
  font-size: 20px;
  height: 34px;
  justify-content: center;
  padding: 0;
  width: 34px;
}

.lot-actions-menu ::v-deep .lot-actions-toggle:hover,
.lot-actions-menu.show ::v-deep .lot-actions-toggle {
  background: #e4f6f0;
  border-color: #bee2dc;
  color: #008e75;
  text-decoration: none;
}

.lot-actions-menu ::v-deep .dropdown-menu {
  border: 1px solid #dfe6ef;
  border-radius: 7px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.14);
  min-width: 150px;
  padding: 6px;
}

.lot-actions-menu ::v-deep .dropdown-item {
  align-items: center;
  border-radius: 5px;
  color: #172033;
  display: flex;
  font-size: 13px;
  font-weight: 700;
  gap: 8px;
  padding: 8px 10px;
}

.lot-actions-menu ::v-deep .dropdown-item i {
  color: #008e75;
  font-size: 17px;
}

.lot-empty {
  color: #647084;
  text-align: center;
}

.lot-table-footer {
  align-items: center;
  background: #fff;
  border-top: 1px solid #dfe6ef;
  color: #647084;
  display: flex;
  justify-content: space-between;
  padding: 16px 20px;
}

.lot-table-footer .pagination {
  margin: 0;
}

.lot-form-grid {
  display: grid;
  gap: 18px;
  grid-template-columns: minmax(0, 1fr);
}

.lot-form-main {
  display: grid;
  gap: 18px;
}

.lot-form-card {
  background: #fff;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
}

.lot-form-card {
  padding: 22px 26px 24px;
}

.lot-form-card h2 {
  align-items: center;
  color: #172033;
  display: flex;
  font-size: 17px;
  font-weight: 800;
  gap: 10px;
  margin: 0 0 22px;
}

.lot-form-card h2 i {
  align-items: center;
  background: #dff3ec;
  border-radius: 5px;
  color: #008e75;
  display: inline-flex;
  font-size: 17px;
  height: 32px;
  justify-content: center;
  width: 32px;
}

.lot-form-fields {
  display: grid;
  gap: 20px 24px;
}

.lot-form-fields.two-columns {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.lot-form-fields.three-columns {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.lot-form-fields.has-separator {
  border-top: 1px solid #edeff4;
  margin-top: 20px;
  padding-top: 24px;
}

.lot-form-card ::v-deep label {
  color: #2d3748;
  font-size: 13px;
  font-weight: 800;
  margin-bottom: 8px;
}

.lot-form-card ::v-deep .form-control,
.lot-form-card ::v-deep .custom-select,
.lot-form-card ::v-deep .b-form-datepicker {
  background: #fff;
  border-color: #d8dee8;
  border-radius: 5px;
  color: #172033;
  font-weight: 600;
  min-height: 44px;
}

.lot-form-card ::v-deep .lot-date-field {
  align-items: center;
  display: flex;
  height: 44px;
}

.lot-form-card ::v-deep .lot-date-field > .btn {
  align-items: center;
  background: #fff;
  border: 0;
  color: #008e75;
  display: inline-flex;
  height: 42px;
  justify-content: center;
  min-width: 42px;
  padding: 0;
}

.lot-form-card ::v-deep .lot-date-field > .btn:hover,
.lot-form-card ::v-deep .lot-date-field > .btn:focus {
  background: #e4f6f0;
  box-shadow: none;
}

.lot-form-card ::v-deep .lot-date-field label.form-control {
  align-items: center;
  border: 0;
  box-shadow: none;
  color: #172033;
  display: flex;
  font-size: 13px;
  font-weight: 600;
  height: 42px;
  margin: 0;
  min-height: 42px;
  padding-left: 10px;
}

.lot-form-card ::v-deep .style-select .vs__dropdown-toggle {
  background: #fff;
  border: 1px solid #d8dee8;
  border-radius: 5px;
  min-height: 44px;
  padding: 0 8px;
}

.lot-form-card ::v-deep .style-select .vs__selected-options {
  align-items: center;
  min-height: 42px;
  padding: 0;
}

.lot-form-card ::v-deep .style-select .vs__selected,
.lot-form-card ::v-deep .style-select .vs__search,
.lot-form-card ::v-deep .style-select .vs__search::placeholder {
  color: #172033;
  font-size: 13px;
  font-weight: 600;
  margin: 0;
}

.lot-form-card ::v-deep .style-select .vs__actions {
  padding: 0 2px 0 8px;
}

.lot-form-card ::v-deep .style-select .vs__dropdown-menu {
  border: 1px solid #d8dee8;
  border-radius: 0 0 5px 5px;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
  font-size: 13px;
  max-height: 240px;
}

.lot-form-card ::v-deep .style-select .vs__dropdown-option {
  padding: 9px 12px;
}

.lot-form-card ::v-deep .style-select .vs__dropdown-option--highlight {
  background: #008e75;
}

.lot-form-card ::v-deep .style-select.vs--open .vs__dropdown-toggle {
  border-color: #008e75;
  box-shadow: 0 0 0 3px rgba(0, 142, 117, 0.12);
}

.lot-autocomplete {
  position: relative;
}

.lot-autocomplete .form-control {
  padding-right: 42px;
}

.lot-autocomplete-clear {
  align-items: center;
  background: transparent;
  border: 0;
  color: #34405c;
  display: inline-flex;
  font-size: 18px;
  height: 34px;
  justify-content: center;
  position: absolute;
  right: 6px;
  top: 5px;
  width: 34px;
  z-index: 4;
}

.lot-autocomplete-menu {
  background: #fff;
  border: 1px solid #d8dee8;
  border-radius: 0 0 5px 5px;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
  left: 0;
  max-height: 240px;
  overflow-y: auto;
  position: absolute;
  right: 0;
  top: calc(100% + 2px);
  z-index: 30;
}

.lot-autocomplete-item {
  background: #fff;
  border: 0;
  border-bottom: 1px solid #eef2f7;
  color: #172033;
  display: block;
  padding: 10px 12px;
  text-align: left;
  width: 100%;
}

.lot-autocomplete-item:hover {
  background: #e4f6f0;
}

.lot-autocomplete-item span {
  display: block;
  font-size: 13px;
  font-weight: 800;
}

.lot-autocomplete-item small {
  color: #536074;
  font-size: 11px;
  font-style: normal;
  margin-top: 3px;
}

.lot-autocomplete-state {
  color: #536074;
  font-size: 13px;
  font-weight: 700;
  padding: 12px;
}

.lot-form-card ::v-deep textarea.form-control {
  height: auto;
}

.lot-form-card ::v-deep .input-group-text {
  background: #fff;
  border-color: #d8dee8;
  color: #172033;
  font-size: 12px;
  font-weight: 800;
}

.lot-form-card small {
  color: #536074;
  display: block;
  font-size: 11px;
  font-style: italic;
  margin-top: 8px;
}

.lot-radio-group ::v-deep .custom-control {
  margin-right: 18px;
}

.lot-radio-group ::v-deep .custom-control-label {
  font-size: 13px;
  font-weight: 700;
}

@media (max-width: 1199px) {
  .lot-kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

}

@media (max-width: 767px) {
  .lot-page-actions,
  .lot-table-footer {
    align-items: stretch;
    flex-direction: column;
  }

  .lot-page-actions .btn,
  .lot-filter-toolbar .btn {
    width: 100%;
  }

  .lot-filter-toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .lot-kpi-grid,
  .lot-form-grid,
  .lot-form-fields.two-columns,
  .lot-form-fields.three-columns {
    grid-template-columns: 1fr;
  }
}
</style>
